import WebMenu from './WebMenu';

export default WebMenu;
